import React from 'react'
import { Row } from 'antd'
import { FooterAbout, Column, UsefulLinks, RecentPost } from './'

function ThemeFooter() {
    return (
        <footer style={{ borderTop: '1px solid rgba(0, 0, 0, 0.08)' }}>
            <Row>
                <Column
                    xs={{ span: 24, order: 3 }}
                    md={{ span: 24, order: 3 }}
                    lg={{ span: 8, order: 1 }}
                    xl={8}
                >
                    <FooterAbout src="/img/project/logo.png" latest={false} />
                </Column>
                <Column
                    xs={{ span: 24, order: 1 }}
                    md={{ span: 24, order: 1 }}
                    lg={{ span: 8, order: 2 }}
                    xl={8}
                >
                    <UsefulLinks />
                </Column>
                <Column
                    xs={{ span: 24, order: 2 }}
                    md={{ span: 24, order: 2 }}
                    lg={{ span: 8, order: 3 }}
                    xl={8}
                >
                    <RecentPost />
                </Column>
            </Row>
        </footer>
    )
}

export default ThemeFooter
